(function () {
  'use strict';

  var CARD_SELECTOR = [
    '.products-list .box.product',
    '.products .box.product',
    '.search-results .box.product',
    '.collection .box.product',
    '.product-card',
    '.product-item',
    '[data-product-handle]',
    '[data-product-id]'
  ].join(', ');

  var CACHE_PREFIX = 'bioss:card-conjugation:v40:';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var MAX_CARDS_PER_SCAN = 160;
  var RESCAN_DELAY_MS = 200;
  var PERIODIC_RESCAN_MS = 2200;
  var PERIODIC_RESCAN_LIMIT_MS = 120000;
  var startedAt = Date.now();
  var scanTimer = null;
  var requests = {};

  function isProductPage() {
    var body = document.body;
    return !!(body && body.classList && body.classList.contains('template-product'));
  }

  function removeProductPageCardBadges(root) {
    if (!isProductPage()) return;
    root = root || document;

    Array.prototype.slice.call(root.querySelectorAll(
      '.product-details .bioss-card-conjugation-badge, ' +
      '[data-bioss-product-page-conj-placeholder] .bioss-card-conjugation-badge, ' +
      '[data-bioss-product-page-conjugation-options] .bioss-card-conjugation-badge'
    )).forEach(function (badge) {
      if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    });
  }

  function isProductPageConjugationBlock(card) {
    if (!card || !isProductPage()) return false;

    if (
      card.matches &&
      card.matches('[data-bioss-product-page-conj-placeholder], [data-bioss-product-page-conjugation-options]')
    ) {
      return true;
    }

    return !!(
      card.closest &&
      card.closest('.product-details, [data-bioss-product-page-conj-placeholder], [data-bioss-product-page-conjugation-options]')
    );
  }

  var COLOR_MAP = {
    'BIOTIN': '#73caee',
    'HRP': '#8f8f8f',
    'APC': '#ff3131',
    'PE': '#ff8a00',
    'FITC': '#00d829',
    'FITC PLUS': '#00d829',
    'CORALITE PLUS 405': '#004aad',
    'CORALITE PLUS 488': '#00d829',
    'CORALITE PLUS 555': '#d6ff00',
    'CORALITE PLUS 647': '#ff3131',
    'CORALITE PLUS 750': '#9b0000',
    'CORALITE 594': '#ff7a00',
    'CORALITE 700': '#b00000',
    'CORALUX VIOLET 510': '#2cd4bf',
    'ABBY FLUOR 350': '#7b61ff',
    'ABBY FLUOR 405': '#004aad',
    'ABBY FLUOR 488': '#00d829',
    'ABBY FLUOR 555': '#d6ff00',
    'ABBY FLUOR 594': '#ff7a00',
    'ABBY FLUOR 647': '#ff3131',
    'ABBY FLUOR 680': '#9b0000',
    'ABBY FLUOR 750': '#6d0000',
    'CY3': '#ff7a00',
    'CY5': '#ff3131',
    'CY5.5': '#d60057',
    'CY7': '#8c0000',
    'CYANINE3': '#ff7a00',
    'CYANINE5': '#ff3131',
    'CYANINE5.5': '#d60057',
    'CYANINE7': '#8c0000',
    'PERCP': '#8a2be2',
    'PERCP CYANINE5.5': '#8a2be2',
    'PE CYANINE5.5': '#ff8a00',
    'PE CYANINE7': '#ff8a00',
    'APC CYANINE5.5': '#ff3131',
    'APC CYANINE7': '#ff3131'
  };

  function normalizeText(text) {
    return (text || '').replace(/&nbsp;/gi, ' ').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function cleanKey(text) {
    return normalizeText(text)
      .replace(/®/g, '')
      .replace(/[–—_]+/g, '-')
      .replace(/\s*-\s*/g, ' ')
      .replace(/\s+/g, ' ')
      .toUpperCase();
  }

  function absolutizeProductUrl(url) {
    if (!url) return '';
    url = String(url).split('#')[0].trim();
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? '/products/' + match[1] : '';
  }

  function productUrlFromCard(card) {
    if (!card) return '';

    var direct = card.getAttribute('data-product-url') || card.getAttribute('data-url') || '';
    if (direct && direct.indexOf('/products/') !== -1) return absolutizeProductUrl(direct);

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (handle) return '/products/' + String(handle).replace(/^\/products\//, '').replace(/^\//, '').split(/[?#]/)[0];

    var imageSlot = card.querySelector('[data-bioss-product-card-image], .bioss-card-image-loader, .bioss-card-image-injected');
    if (imageSlot) {
      var slotUrl = imageSlot.getAttribute('data-product-url');
      if (slotUrl && slotUrl.indexOf('/products/') !== -1) return absolutizeProductUrl(slotUrl);

      var endpoint = imageSlot.getAttribute('data-images-endpoint') || '';
      if (endpoint && endpoint.indexOf('/products/') !== -1) return absolutizeProductUrl(endpoint);
    }

    var link = card.querySelector('a.product-title[href], header a[href*="/products/"], h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return '';
    return absolutizeProductUrl(href);
  }

  function productHandle(productUrl) {
    var match = productUrl && productUrl.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? match[1] : '';
  }

  function endpointFromProductUrl(productUrl) {
    var handle = productHandle(productUrl);
    return handle ? '/products/' + handle + '?view=card-conjugation&bioss_conj_v=40' : '';
  }

  function cacheKey(endpoint) {
    return endpoint ? CACHE_PREFIX + endpoint : '';
  }

  function readCache(endpoint) {
    var key = cacheKey(endpoint);
    if (!key || !window.localStorage) return null;
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expires || parsed.expires < Date.now()) {
        window.localStorage.removeItem(key);
        return null;
      }
      return parsed.payload || null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(endpoint, payload) {
    var key = cacheKey(endpoint);
    if (!key || !payload || !window.localStorage) return;
    try {
      window.localStorage.setItem(key, JSON.stringify({
        payload: payload,
        expires: Date.now() + CACHE_TTL_MS
      }));
    } catch (error) {}
  }

  function parsePayloadText(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      var start = text.indexOf('{');
      var end = text.lastIndexOf('}');
      if (start > -1 && end > start) {
        try { return JSON.parse(text.slice(start, end + 1)); } catch (e) {}
      }
    }
    return null;
  }

  function fetchJson(endpoint) {
    if (!endpoint || !window.fetch) return Promise.resolve(null);

    var cached = readCache(endpoint);
    if (cached) return Promise.resolve(cached);

    if (requests[endpoint]) return requests[endpoint];

    requests[endpoint] = window.fetch(endpoint, {
      credentials: 'same-origin',
      cache: 'force-cache'
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.text();
      })
      .then(function (text) {
        var payload = parsePayloadText(text);
        if (payload) writeCache(endpoint, payload);
        return payload;
      })
      .catch(function () { return null; });

    return requests[endpoint];
  }

  function isUnconjugated(value) {
    value = cleanKey(value);
    if (!value) return true;
    return /(^|\s)(UNCONJUGATED|NCONJUGATED|NONE|NO CONJUGATION|DEFAULT TITLE)($|\s)/i.test(value);
  }

  function isSizeToken(value) {
    value = normalizeText(value).replace(/[(),]/g, '').trim();
    if (!value) return false;

    return /^\d+(?:\.\d+)?\s*(?:t|tests?|rxns?|reactions?|mg|g|kg|ng|ug|mcg|\u00b5g|\u03bcg|ul|\u00b5l|\u03bcl|ml|l)$/i.test(value) ||
      /^\d+(?:\.\d+)?\s*(?:mg|g|kg|ng|ug|mcg|\u00b5g|\u03bcg)\s*\/\s*(?:ul|\u00b5l|\u03bcl|ml|l)$/i.test(value);
  }

  function stripSizeTokens(label) {
    label = normalizeText(label);
    if (!label) return '';

    var normalized = label
      .replace(/[–—_]+/g, '-')
      .replace(/\s*-\s*/g, '-')
      .trim();

    var parts = normalized.split('-');
    while (parts.length && isSizeToken(parts[parts.length - 1])) {
      parts.pop();
    }

    var stripped = parts.join('-');
    if (stripped === normalized) {
      stripped = stripped
        .replace(/\s+\d+(?:\.\d+)?\s*(?:t|tests?|rxns?|reactions?|mg|g|kg|ng|ug|mcg|\u00b5g|\u03bcg|ul|\u00b5l|\u03bcl|ml|l)\s*$/i, '')
        .replace(/\s+\d+(?:\.\d+)?\s*(?:mg|g|kg|ng|ug|mcg|\u00b5g|\u03bcg)\s*\/\s*(?:ul|\u00b5l|\u03bcl|ml|l)\s*$/i, '');
    }

    return normalizeText(stripped);
  }

  function suffixFromSku(sku) {
    sku = normalizeText(sku);
    if (!sku) return '';

    // Bioss conjugated SKUs are commonly base-SKU-suffix, e.g. bs-1049R-BF555 or bsm-12345R-PE-Cy7.
    var match = sku.match(/^[a-z]+-\d+[a-z0-9]*-(.+)$/i);
    return match && match[1] ? match[1] : '';
  }

  function firstSkuFromPayload(payload) {
    if (!payload) return '';
    if (payload.sku) return payload.sku;
    if (Array.isArray(payload.variant_skus)) {
      for (var i = 0; i < payload.variant_skus.length; i += 1) {
        if (payload.variant_skus[i] && payload.variant_skus[i].sku) return payload.variant_skus[i].sku;
      }
    }
    return '';
  }

  function normalizeConjugationLabel(raw) {
    raw = normalizeText(raw);
    if (!raw || isUnconjugated(raw)) return '';

    raw = raw
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/CoraLite/gi, 'Coralite')
      .replace(/CoralLite/gi, 'Coralite')
      .replace(/Abby\s*Fluor/gi, 'AbBy Fluor')
      .replace(/AbBy\s*Fluor\s*®/gi, 'AbBy Fluor®')
      .replace(/\s*-\s*/g, '-')
      .trim();

    raw = stripSizeTokens(raw);
    if (!raw || isUnconjugated(raw)) return '';

    var key = cleanKey(raw).replace(/\s+/g, '');

    // SKU shorthand first: BF555, FITC, PE-Cy7, APC-Cy7, etc.
    var bf = key.match(/^(BF|AF|ABBYFLUOR)(350|405|488|555|594|647|680|750)$/i);
    if (bf) return 'BF' + bf[2];

    var coralPlus = key.match(/^CORALITEPLUS(405|488|555|647|750)$/i);
    if (coralPlus) return 'Coralite® Plus ' + coralPlus[1];

    var coral = key.match(/^CORALITE(594|700)$/i);
    if (coral) return 'Coralite®' + coral[1];

    var coralux = key.match(/^CORALUXVIOLET510$/i);
    if (coralux) return 'CoraLux Violet 510';

    // Shorten Cyanine labels to Cy labels for product-card compactness.
    raw = raw
      .replace(/Cyanine\s*([0-9.]+)/gi, 'Cy$1')
      .replace(/Cy\s*([0-9.]+)/gi, 'Cy$1')
      .replace(/PE-Cy([0-9.]+)$/i, 'PE-Cy$1')
      .replace(/APC-Cy([0-9.]+)$/i, 'APC-Cy$1')
      .replace(/PerCP-Cy([0-9.]+)$/i, 'PerCP-Cy$1');

    // Compact common conjugations. Do not display FITC Plus on product cards.
    raw = raw.replace(/^FITC(?:\s*Plus)?$/i, 'FITC');
    raw = raw.replace(/^HRP$/i, 'HRP');
    raw = raw.replace(/^APC$/i, 'APC');
    raw = raw.replace(/^PE$/i, 'PE');
    raw = raw.replace(/^Biotin$/i, 'Biotin');

    // Keep common double-conjugation shorthand consistent.
    raw = raw.replace(/^PE[-\s]*Cy([0-9.]+)$/i, 'PE-Cy$1');
    raw = raw.replace(/^APC[-\s]*Cy([0-9.]+)$/i, 'APC-Cy$1');
    raw = raw.replace(/^PerCP[-\s]*Cy([0-9.]+)$/i, 'PerCP-Cy$1');

    return raw;
  }

  function deriveConjugation(payload) {
    if (!payload) return null;

    var candidates = [
      payload.conjugation_value,
      payload.conjugation,
      payload.theme_conjugate_value,
      payload.theme_conjugate,
      payload.custom_conjugation_value,
      payload.custom_conjugation,
      payload.custom_conjugation_caps_value,
      payload.custom_conjugation_caps,
      payload.custom_conjugate_value,
      payload.custom_conjugate
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var label = normalizeConjugationLabel(candidates[i]);
      if (label) return label;
    }

    var sku = firstSkuFromPayload(payload);
    var suffix = suffixFromSku(sku);
    var fallback = normalizeConjugationLabel(suffix);
    if (fallback) return fallback;

    fallback = normalizeConjugationLabel(payload.title || '');
    if (fallback && !/antibody|protein|compound|kit/i.test(fallback)) return fallback;

    return null;
  }

  function displayConjugationLabel(label) {
    label = normalizeConjugationLabel(label);
    if (!label) return '';

    label = label
      .replace(/FITC\s*Plus/gi, 'FITC')
      .replace(/Cyanine\s*([0-9.]+)/gi, 'Cy$1')
      .replace(/Cy\s*([0-9.]+)/gi, 'Cy$1')
      .replace(/PE[-\s]*Cy([0-9.]+)/gi, 'PE-Cy$1')
      .replace(/APC[-\s]*Cy([0-9.]+)/gi, 'APC-Cy$1')
      .replace(/PerCP[-\s]*Cy([0-9.]+)/gi, 'PerCP-Cy$1');

    var bf = cleanKey(label).replace(/\s+/g, '').match(/^ABBYFLUOR(350|405|488|555|594|647|680|750)$/i);
    if (bf) return 'BF' + bf[1];

    return label;
  }

  function colorForToken(token) {
    token = cleanKey(token);
    if (!token) return '';

    if (COLOR_MAP[token]) return COLOR_MAP[token];

    if (/^BF(350|405|488|555|594|647|680|750)$/.test(token)) {
      var wavelength = token.replace(/^BF/, '');
      return colorForToken(wavelength);
    }
    if (/BIOTIN/.test(token)) return COLOR_MAP.BIOTIN;
    if (/HRP/.test(token)) return COLOR_MAP.HRP;
    if (/FITC/.test(token) || /488/.test(token)) return '#00d829';
    if (/405|350/.test(token)) return '#004aad';
    if (/555/.test(token)) return '#d6ff00';
    if (/594|CYANINE3|CY3|PE/.test(token) && !/PERCP/.test(token)) return '#ff8a00';
    if (/647|CYANINE5|CY5|APC/.test(token)) return '#ff3131';
    if (/680|700|750|CYANINE7|CY7/.test(token)) return '#8c0000';
    if (/PERCP/.test(token)) return '#8a2be2';
    if (/VIOLET|510/.test(token)) return '#2cd4bf';

    return '#371499';
  }

  function colorsForLabel(label) {
    var normalized = normalizeText(label).replace(/\s*-\s*/g, '-');
    var parts = normalized.split('-').filter(function (part) { return normalizeText(part); });

    if (parts.length > 1) {
      return parts.map(colorForToken).filter(Boolean).slice(0, 2);
    }

    return [colorForToken(normalized)];
  }

  function circleBackground(label) {
    var colors = colorsForLabel(label);
    if (!colors.length) return '#371499';
    if (colors.length === 1) return colors[0];
    return 'conic-gradient(' + colors[0] + ' 0 50%, ' + colors[1] + ' 0 100%)';
  }

  function descriptionContainer(card) {
    return card.querySelector('.description.rte, .description, figcaption, .product-card__info, .product-item__info') || card;
  }

  function findInsertionPoint(card) {
    if (!card) return null;

    var conjugate = null;
    var reactivity = null;
    var container = descriptionContainer(card);
    var candidates = container.querySelectorAll('p, li, div, span');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = normalizeText(candidates[i].textContent || '');
      if (/^Conjugate\s*:/i.test(text) || /\bConjugate\s*:/i.test(text)) {
        conjugate = candidates[i];
        break;
      }
    }
    if (conjugate) return conjugate;

    var cite = card.querySelector('.bioss-citeab-card-citations[data-bioss-citeab-card]');
    if (cite) return cite;

    for (var j = 0; j < candidates.length; j += 1) {
      var text = normalizeText(candidates[j].textContent || '');
      if (/^Reactivity\s*:/i.test(text) || /\bReactivity\s*:/i.test(text)) {
        reactivity = candidates[j];
        break;
      }
    }
    if (reactivity) return reactivity;

    var appPills = card.querySelector('.bioss-card-application-pills');
    if (appPills) return appPills;

    return container;
  }

  function renderBadge(card, label, productUrl) {
    label = displayConjugationLabel(label);
    if (!card || !label) return false;

    var existing = card.querySelector('.bioss-card-conjugation-badge');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

    var badge = document.createElement(productUrl ? 'a' : 'div');
    badge.className = 'bioss-card-conjugation-badge';
    badge.setAttribute('data-bioss-card-conjugation', label);

    if (productUrl) {
      badge.href = productUrl;
      badge.setAttribute('aria-label', 'View product with ' + label + ' conjugation');
      badge.addEventListener('click', function (event) {
        event.stopPropagation();
      }, true);
    }

    var dot = document.createElement('span');
    dot.className = 'bioss-card-conjugation-dot';
    dot.style.background = circleBackground(label);

    var text = document.createElement('span');
    text.className = 'bioss-card-conjugation-label';
    text.textContent = label;

    badge.appendChild(dot);
    badge.appendChild(text);

    var insertionPoint = findInsertionPoint(card);
    if (insertionPoint && insertionPoint.parentNode) {
      insertionPoint.parentNode.insertBefore(badge, insertionPoint.nextSibling);
    } else {
      descriptionContainer(card).appendChild(badge);
    }

    card.setAttribute('data-bioss-card-conjugation-loaded', 'true');
    return true;
  }

  function processCard(card) {
    if (!card || card.getAttribute('data-bioss-card-conjugation-loaded') === 'true') return;
    if (isProductPageConjugationBlock(card)) {
      removeProductPageCardBadges(card);
      card.setAttribute('data-bioss-card-conjugation-loaded', 'none');
      return;
    }

    var productUrl = productUrlFromCard(card);
    var endpoint = endpointFromProductUrl(productUrl);
    if (!endpoint) return;

    card.setAttribute('data-bioss-card-conjugation-loaded', 'loading');

    fetchJson(endpoint).then(function (payload) {
      var label = deriveConjugation(payload);
      if (label) {
        renderBadge(card, label, productUrl);
      } else {
        card.setAttribute('data-bioss-card-conjugation-loaded', 'none');
      }
    }).catch(function () {
      card.removeAttribute('data-bioss-card-conjugation-loaded');
    });
  }

  function scanCards() {
    removeProductPageCardBadges();

    var cards = document.querySelectorAll(CARD_SELECTOR);
    var processed = 0;
    for (var i = 0; i < cards.length; i += 1) {
      processCard(cards[i]);
      processed += 1;
      if (processed >= MAX_CARDS_PER_SCAN) break;
    }
  }

  function resetLoading() {
    var loading = document.querySelectorAll('[data-bioss-card-conjugation-loaded="loading"]');
    for (var i = 0; i < loading.length; i += 1) {
      loading[i].removeAttribute('data-bioss-card-conjugation-loaded');
    }
  }

  function scheduleScan() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scanCards();
    }, RESCAN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }

  window.addEventListener('load', function () {
    resetLoading();
    scheduleScan();
    window.setTimeout(scheduleScan, 900);
    window.setTimeout(scheduleScan, 2200);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { scheduleScan(); });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.searchspring-facets, .filter-menu, .collection-sidebar, .pagination')) {
      window.setTimeout(function () { resetLoading(); scheduleScan(); }, 300);
      window.setTimeout(function () { resetLoading(); scheduleScan(); }, 900);
      window.setTimeout(function () { resetLoading(); scheduleScan(); }, 1800);
    }
  });

  var periodic = window.setInterval(function () {
    if (Date.now() - startedAt > PERIODIC_RESCAN_LIMIT_MS) {
      window.clearInterval(periodic);
      return;
    }
    resetLoading();
    scheduleScan();
  }, PERIODIC_RESCAN_MS);
})();
